export function positionSuggestions(settings) {
  const { state, props, decoratorRect, popover } = settings;

  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;

  const bottomDistance = windowHeight - (decoratorRect.bottom + popover.offsetHeight);
  const rightDistance = windowWidth - (decoratorRect.right + popover.offsetWidth);

  if (state.isActive && props.suggestions.length > 0) {
    const positionAttr = {};
    if (bottomDistance > 10) {
      positionAttr.top = `${decoratorRect.bottom + 20}px`;
      if (rightDistance > 10) {
        positionAttr.transform = 'scale(1)';
      } else {
        positionAttr.transform = 'scale(1) translateX(-50%)';
      }
    } else {
      positionAttr.top = `${decoratorRect.top - 20}px`;
      if (rightDistance > 10) {
        positionAttr.transform = 'scale(1) translateY(-100%)';
      } else {
        positionAttr.transform = 'scale(1) translateX(-50%) translateY(-100%)';
      }
    }
    return {
      left: `${settings.decoratorRect.left}px`,
      // top: settings.decoratorRect.top - 40 + 'px',
      ...positionAttr,
      display: 'block',
      // transform: 'scale(1) translateY(-100%)',
      transformOrigin: '1em 0% 0px',
      transition: 'all 0.25s cubic-bezier(0.3, 1.2, 0.2, 1)',
    };
  }
  return {};
}
